import { Localizable } from '@components/localizable/Localizable'
import { ComplementaryItem as ComplementaryItemModel } from '@models/balance/ComplementaryItem'
import { selectComplementaryItemById } from '@store/balance/ComplementaryItemReducer'
import { useAppSelector } from '@store/hooks'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Flex, Typography } from 'antd'
import { FC } from 'react'

const { Text } = Typography

type Props = SBModelComponent<ComplementaryItemModel> & {}

const ComplementaryItemAvatar: FC<Props> = ({ id, model }) => {
  const item = model ?? useAppSelector(selectComplementaryItemById(id!))

  if (!item) {
    return <></>
  }
  return (
    <Flex gap={10} vertical>
      <Localizable.Render
        item={item}
        render={(localizedItem, lang) => (
          <Text>
            {lang.flag} {localizedItem.name}
          </Text>
        )}
      />
    </Flex>
  )
}

type ComplementaryItemAvatarType = { Avatar: typeof ComplementaryItemAvatar }

export { ComplementaryItemAvatar, type ComplementaryItemAvatarType }
